(() => {
  'use strict';

  class PdpBenefitCard extends HTMLElement {
    connectedCallback() {
      this.front = this.querySelector('.pdp-benefits__front');
      this.back = this.querySelector('.pdp-benefits__back');
      this.toggleBtn = this.querySelector('.pdp-benefits__toggle');

      if (!this.front || !this.back || !this.toggleBtn) return;

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick() {
      this.setOpen(!this.classList.contains('is-open'));
    }

    setOpen(open) {
      this.classList.toggle('is-open', open);
      this.back.hidden = !open;
      this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  if (!customElements.get('pdp-benefit-card')) {
    customElements.define('pdp-benefit-card', PdpBenefitCard);
  }
})();
